import type { Ref, SVGProps } from 'react'
import { cx } from '@/shared/lib'
import { ICON_PATHS, type IconName } from './icons'
import s from './Icon.module.css'

/**
 * Ступени шкалы. Кит использует 15 размеров (9…26) — они сведены к четырём,
 * обоснование в docs/ui-kit/contracts/icon.md.
 */
export type IconSize = 'xs' | 'sm' | 'md' | 'lg'

export type IconProps = {
  name: IconName
  size?: IconSize
  /** Доступное имя. Задано — иконка смысловая; не задано — декоративная и скрыта от скринридера. */
  label?: string
  ref?: Ref<SVGSVGElement>
} & Omit<SVGProps<SVGSVGElement>, 'name' | 'title' | 'children'>

/**
 * Единственный источник векторной графики. Цвет не задаётся внутри:
 * обводка идёт currentColor и наследует цвет контейнера.
 */
export function Icon({ name, size = 'md', label, className, ref, ...rest }: IconProps) {
  return (
    <svg
      {...rest}
      ref={ref}
      viewBox="0 0 24 24"
      className={cx(s.root, s[size], className)}
      data-icon={name}
      data-size={size}
      focusable="false"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  )
}
